import { analyticsUtils } from 'utils/analytics-utils';
import { getPathname } from 'utils/get-pathname';

// Событие срабатывает при клике на баннер замера.

export const gaClickMeasurementBanner = ({
  catalogueLevel,
  title,
}: {
  catalogueLevel: number;
  title: string;
}) => {
  const path = getPathname();

  return analyticsUtils.sendEvent('GA:promoClick', {
    elementType: 'banner',
    elementBlock: `${path}:lvl${catalogueLevel}`, // блок, в котором расположен элемент
    promotions: [
      {
        name: 'Проекты PLP / Дверь по вашим параметрам',
        creative: title,
        position: 1,
      },
    ],
  });
};
